// Interactive presentations (design/2026-11-03-presentations.md): a web app
// laid out as slides, and "Start a new chat from here" on any web app in
// DataViz. Opened on a web app's page in DataViz
// (/dashboards/:customer/:id/view?walkthrough=presentations). It presses
// Start a new chat from here, which only keeps a pending copy and opens the
// start screen; it never presses Send, so no chat is created.

import type { Walkthrough } from './types'

export const presentations: Walkthrough = {
  slug: 'presentations',
  title: 'Presentations',
  summary:
    'Shows a presentation in DataViz, how to ask about a slide or a figure, and the start screen a new chat opens on. Nothing is sent and no chat is created.',
  added: '2026-11-03',
  skipE2E:
    'starts on a published web app (/dashboards/:customer/:id/view) and needs one to exist; the spec opens Tables on the fixture job',
  steps: [
    {
      route: 'dashboard-view',
      feature: 'storyboards/in-dataviz',
      control: 'Download PDF',
      say: 'This is a presentation in DataViz: a web app laid out as slides, with its own type, Presentation, in the list. Download PDF prints every slide and every layer, in order.',
    },
    {
      route: 'dashboard-view',
      feature: 'storyboards/presentation',
      say: 'Each slide states one finding. The arrow keys move between slides. Explore under a figure opens a layer of evidence over the slide, and Esc closes it. All slides shows the whole presentation in one column.',
    },
    {
      route: 'dashboard-view',
      feature: 'storyboards/ask-from-presentation',
      say: 'Ask about this, in the presentation’s bar, asks about the slide or layer on screen. Click a figure and its source dialog has Ask about this figure. A link ending ?at=slide/layer opens the presentation at that point.',
    },
    {
      route: 'dashboard-view',
      feature: 'storyboards/ask-from-presentation',
      control: 'Start a new chat from here',
      click: 'Start a new chat from here',
      say: 'I pressed Start a new chat from here. It keeps a copy of this web app for a new chat and opens the start screen. No chat exists yet.',
    },
    {
      route: 'agent-new',
      feature: 'storyboards/ask-from-presentation',
      say: 'The chip in the message box names the web app, and the slide or figure if you asked from one. The chat starts on the web app’s job. Send creates the chat and then copies the web app into it, for the agent to read. The close icon on the chip starts an ordinary chat instead. A walkthrough never presses Send.',
    },
    {
      route: 'agent-new',
      feature: 'storyboards/ask-from-presentation',
      say: 'Start a new chat from here is greyed out when you are not signed in, when your AI access does not allow chats, when the web app is another customer’s, or while it is still saving. Its tooltip says which.',
    },
  ],
}
